module.exports = __webpack_public_path__ + "static/img/icon_slide_prev_dark.a44ad67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_slide_prev_dark.svg
// module id = e1+/
// module chunks = 10